(function (angular) {
    'use strict';

    angular.module('settings')

        /**
         *
         */
        .factory('usersService',
            ['$http', '$q', 'portalConfig', 'sharedDataService',
                function ($http, $q, portalConfig, sharedDataService) {

                    var urlBase = portalConfig.urlBase;
                    //urlBase = 'http://localhost:8001';

                    var fac = {
                        getUsers: getUsers,
                        getUser: getUser,
                        createUser: createUser,
                        updateUser: updateUser,
                        deleteUser: deleteUser,
                        getRoles: getRoles,
                        refreshUsers: refreshUsers
                    };

                    return fac;

                    function getRoles() {

                        return $http.get(urlBase + "/membership/roles")
                            .then(getRolesComplete)
                            .catch(getRolesFailed);

                        function getRolesComplete(response) {
                            return response.data;
                        }

                        function getRolesFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    function getUsers(accountId) {
                        if (sharedDataService.getUsers()) {
                            return $q.resolve(sharedDataService.getUsers());
                        }
                        else {

                            return $http.get(urlBase + "/membership/accounts/" + accountId + "/users")
                                .then(getUsersComplete)
                                .catch(getUsersFailed);
                        }

                        function getUsersComplete(response) {
                            sharedDataService.setUsers(response.data);
                            return response.data;
                        }

                        function getUsersFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    function refreshUsers(accountId) {
                        return $http.get(urlBase + "/membership/accounts/" + accountId + "/users")
                            .then(getUsersComplete)
                            .catch(getUsersFailed);

                        function getUsersComplete(response) {
                            sharedDataService.setUsers(response.data);
                            return response.data;
                        }

                        function getUsersFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    function getUser(accountId, userId) {

                        return $http.get(urlBase + "/membership/accounts/" + accountId + "/users/" + userId)
                            .then(getUserComplete)
                            .catch(getUserFailed);

                        function getUserComplete(response) {
                            return response.data;
                        }

                        function getUserFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    function createUser(accountId, user) {

                        return $http.post(urlBase + "/membership/accounts/" + accountId + "/users/", user)
                            .then(getUserComplete)
                            .catch(getUserFailed);

                        function getUserComplete(response) {
                            sharedDataService.addUser(response.data);
                            return response.data;
                        }

                        function getUserFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    function updateUser(accountId, user) {

                        return $http.put(urlBase + "/membership/accounts/" + accountId + "/users/" + user.userId, user)
                            .then(getUserComplete)
                            .catch(getUserFailed);

                        function getUserComplete(response) {
                            sharedDataService.updateUser(response.data);
                            return response.data;
                        }

                        function getUserFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    function deleteUser(accountId, userId) {

                        return $http.delete(urlBase + "/accounts/" + accountId + "/users/" + userId)
                            .then(getUserComplete)
                            .catch(getUserFailed);

                        function getUserComplete(response) {
                            sharedDataService.deleteUser({ userId: userId });
                            return response.data;
                        }

                        function getUserFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                }]);

})(window.angular);